import type { WireStep } from "../../lib/api";
import { OnchainPlan } from "./plan/OnchainPlan";

/**
 * Neutral slate card showing the planner's intended on-chain path
 * (divest / swap / invest legs). Independent of simulation outcome —
 * rendered identically on success and failure so the user always sees
 * "here's what we'd have done" without it being visually tied to the
 * revert reason.
 */
export function IntendedPathCard({ steps }: { steps: WireStep[] }) {
	return (
		<div className="rounded-md border border-slate-700/60 bg-slate-900/40 p-2 text-[11px]">
			<p className="mb-1 font-semibold uppercase tracking-wide text-slate-200">
				Intended path ({steps.length} step{steps.length === 1 ? "" : "s"})
			</p>
			<OnchainPlan steps={steps} />
		</div>
	);
}
